import React, { useState, useCallback, useEffect } from 'react';
import DsaWorkspace from './DsaWorkspace';
import ModeEmpty from './ModeEmpty';
import APIService from '../../services/APIService';
import '../../styles/dsa-workspace.css';

/*
 * DsaMode — driven entirely by the session config (no in-mode topic picker).
 * It opens a problem chosen for the configured DSA topics (from the session
 * plan, else the curator). With no DSA scope it points to Session Settings /
 * the Navigation tab. Free browsing lives in the Navigation tab.
 */
const dsaScope = (config) => (config?.subjects || []).filter((s) => s.id === 'dsa' || s.id.startsWith('dsa.'));

const DsaMode = ({ config, registerSend, onOpenNav, onConfigure }) => {
  const [qid, setQid] = useState(null);
  const [loading, setLoading] = useState(true);
  const open = useCallback((id) => setQid(Number(id)), []);

  const tags = dsaScope(config).map((s) => s.name);
  const planIds = (config?.plan?.by_mode?.dsa || [])
    .map((it) => (it.payload && it.payload.question_id) || it.question_id).filter(Boolean).map(Number);
  const hasScope = tags.length > 0 || planIds.length > 0;

  useEffect(() => {
    let alive = true;
    if (planIds.length) { setQid(planIds[0]); setLoading(false); return () => { alive = false; }; }
    if (tags.length) {
      APIService.engineNext({ topics: tags })
        .then((r) => { if (alive && r && r.item && r.item.question_id) setQid(Number(r.item.question_id)); })
        .catch(() => {})
        .finally(() => { if (alive) setLoading(false); });
    } else if (alive) {
      setLoading(false);
    }
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  if (loading) {
    return <div style={{ padding: 40, color: 'var(--n-text-2, #52586b)' }}>Preparing your DSA questions…</div>;
  }
  if (qid == null) {
    return (
      <ModeEmpty
        title={hasScope ? 'No unsolved problems in your scope' : 'No DSA topics configured'}
        body={hasScope
          ? 'You’ve covered the selected topics. Configure new ones in Session Settings, or browse the full bank.'
          : 'Choose DSA topics in Session Settings and problems will be served here. You can also browse everything in Navigation.'}
        scene="dsa"
        eyebrow="Algorithm practice"
        onConfigure={onConfigure}
        onOpenNav={onOpenNav}
      />
    );
  }
  return (
    <DsaWorkspace
      key={qid}
      questionId={qid}
      config={config}
      registerSend={registerSend}
      onBack={onOpenNav}
      onOpenQuestion={open}
    />
  );
};

export default DsaMode;
